module.exports = __webpack_public_path__ + "static/media/Tablet-community-2.1ab34dd4.jpg";